import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import jkautoLogo from '../assets/jkauto-logo.png';
import { useMenu } from '../context/MenuContext';
import { Link, useLocation } from 'react-router-dom';

interface NavLink {
  to: string;
  label: string;
}

const COMPANY_NAME = 'JK Automations';
const NAV_LINKS: readonly NavLink[] = [
  { to: '/', label: 'Home' },
  { to: '/ai-solutions', label: 'Solutions' },
  { to: '/departments', label: 'Departments' },
  { to: '/integrations', label: 'Integrations' },
  { to: '/about', label: 'About Us' },
  { to: '/contact', label: 'Contact' },
] as const;

const Header: React.FC = () => {
  const { toggleMenu, isMenuOpen } = useMenu();
  const location = useLocation();
  const prefetchAuditRoute = React.useCallback(() => {
    void import('../pages/Audit');
  }, []);

  const navLinks = useMemo(() => NAV_LINKS, []);

  return (
    <header>
      <div className="header-container">
        <button
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          aria-controls="mobile-side-menu"
          type="button"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
        <div className="logo">
          <img
            src={jkautoLogo}
            alt={`${COMPANY_NAME} Logo`}
            className="logo-image"
            width="200"
            height="85"
            loading="eager"
            decoding="async"
          />
          <Link
            to="/"
            className="logo-hit-target"
            aria-label={`${COMPANY_NAME} Home`}
          />
        </div>
        <nav className="desktop-nav" aria-label="Main navigation">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={location.pathname === link.to ? 'active' : ''}
              aria-current={location.pathname === link.to ? 'page' : undefined}
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <Link
          to="/audit"
          className={`cta-button ${location.pathname === '/audit' ? 'active' : ''}`}
          aria-current={location.pathname === '/audit' ? 'page' : undefined}
          onMouseEnter={prefetchAuditRoute}
          onFocus={prefetchAuditRoute}
        >
          Med Spa Audit
        </Link>
        <div className="header-spacer" />
      </div>
    </header>
  );
};

export default React.memo(Header);